
export const SUPABASE_PROJECT_URL = 'https://hbgmfqtsdizjedoanieo.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhiZ21mcXRzZGl6amVkb2FuaWVvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ4MjY0MTgsImV4cCI6MjA2MDQwMjQxOH0.S6w7v1GkO9e7TwQZT4jaNcwWveofgT5OTWqYmlEBb7Q';
